import { type JSX } from 'react';

import { ENERGY_EFFICIENCY_HASH } from '../../constants/energyClass';
import { useOpenDrawer } from '../../hooks/drawer';
import { useLocalization } from '../../providers/LocaleProvider';
import { isClient } from '../../utils/isClient';

interface UseEnergyClassOptions {
  content: JSX.Element;
  labelUrls?: string[];
  shouldHandleEnergyHash: boolean;
}

const removeEnergyHashHandler = () => {
  if (location.hash === ENERGY_EFFICIENCY_HASH) {
    setTimeout(() => {
      history.replaceState(null, '', `${location.pathname}${location.search}`);
    }, 0);
  }
};

export const useEnergyClass = ({
  content,
  labelUrls,
  shouldHandleEnergyHash,
}: UseEnergyClassOptions) => {
  const { t } = useLocalization();

  const openDrawer = useOpenDrawer({
    autoOpen:
      isClient() &&
      shouldHandleEnergyHash &&
      labelUrls.length &&
      location.hash === ENERGY_EFFICIENCY_HASH,
    title: t('h24_energy_class_title'),
    content,
    onCloseComplete: removeEnergyHashHandler,
  });

  return openDrawer;
};
